import { render } from "./Winners.vue?vue&type=template&id=592a7fed"
import script from "./Winners.vue?vue&type=script&lang=js"
export * from "./Winners.vue?vue&type=script&lang=js"
script.render = render

export default script